module.exports = __webpack_public_path__ + "img/screen-2-step-3.5ab78799.png";